/* unplugin-vue-components disabled */import { render } from "./AuthorityManagement.vue?vue&type=template&id=1f985256"
import script from "./AuthorityManagement.vue?vue&type=script&lang=js"
export * from "./AuthorityManagement.vue?vue&type=script&lang=js"

import "./AuthorityManagement.vue?vue&type=style&index=0&id=1f985256&lang=css"

import exportComponent from "/root/steemboylikegirlClub/gitproject/steemboylikegirlclub/steemboylikegirlclub/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__